import { render, staticRenderFns } from "./TrueWalletDeposit.vue?vue&type=template&id=71250804&scoped=true&"
import script from "./TrueWalletDeposit.vue?vue&type=script&lang=js&"
export * from "./TrueWalletDeposit.vue?vue&type=script&lang=js&"
import style0 from "./TrueWalletDeposit.vue?vue&type=style&index=0&id=71250804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71250804",
  null
  
)

export default component.exports